const { cxt } = require('./context');

const {
    common,
} = require('../schema');

const {
    employment,
} = common;

/**
 * Validates the Fee Configuration
 * @type {Array<cxt>}
 * @memberof validators
 */
const employmentValidator = [
    cxt('schema', { schema: employment, opts: { nestedErrors: true } }),
];

module.exports = {
    employment: employmentValidator,
};
